<template>
    <div>
        <banner heading="MEANager" description="WELCOMEMSG" type="home"></banner>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h2 class="page-header">{{ $t('HOWTOPLAY') }}</h2>
                    <ul class="unstyled">
                        <li>{{ $t('HOWTOPLAY_STEP1') }}</li>
                        <li>{{ $t('HOWTOPLAY_STEP2') }}</li>
                        <li>{{ $t('HOWTOPLAY_STEP3') }}</li>
                        <li>{{ $t('HOWTOPLAY_STEP4') }}</li>
                        <li>{{ $t('HOWTOPLAY_STEP5') }}</li>
                        <li>{{ $t('HOWTOPLAY_STEP6') }}</li>
                        <li>{{ $t('HOWTOPLAY_STEP7') }}</li>
                    </ul>
                    <div class="reset-wrapper">
                        <div class="hidden2 confirm" v-if="showConfirm">
                            <strong><span class="confirm-text">{{ $t('DELETE_CONFIRM') }}</span></strong>
                            <span class="confirm-buttons btn-group">
                                <button type="button" class="btn btn-danger" @click="reset()">{{ $t('YES') }}</button>
                                <button type="button" class="btn btn-secondary" @click="setShowConfirm(false)">{{ $t('NO') }}</button>
                            </span>
                        </div>
                        <button type="button" v-else class="btn btn-danger" @click="setShowConfirm(true)">{{ $t('RESET_GAME') }}</button>
                    </div>
                    <hr>
                </div>
                <div class="col-lg-12">
                    <h2 class="page-header">{{ $t('RANKING') }}</h2>
                    <p class="player-count" v-if="playerCount > 0">{{ $t('PLAYER_COUNT', {count: playerCount}) }}</p>
                    <p class="your-stats">{{ $t('YOUR_STATS', {points}) }}</p>
                    <table class="table table-striped global-stats">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>{{ $t('PLAYER') }}</th>
                            <th>{{ $t('POINTS') }}</th>
                            <th>{{ $t('DATE') }}</th>
                        </tr>
                        </thead>
                        <tr class="stats-entry" v-for="(globalStat, i) in filteredStats" :key="globalStat._id">
                            <td><span class="user-rank">{{ i + 1 }}</span></td>
                            <td><span class="user-name">{{ globalStat.name }}</span></td>
                            <td><span class="points">{{ globalStat.points }}</span></td>
                            <td><span class="date">{{ new Date(globalStat.timestamp).toLocaleString() }}</span></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import banner from './Banner.vue';
import SaveService from '../services/save.service';
import StatsService from '../services/stats.service';
export default {
    name:    'home',
    data() {
        let showConfirm = false,
            playerCount = 1,
            globalStats = [];
        StatsService.getStats()
            .then(response => {
                this.globalStats = response.data.slice(0, 25);
            })
            .catch(error => {
                console.error('got error: ', error);
                if (error.response) {
                    console.error('response: ', error.response);
                }
            });
        this.$socket.emit('getPlayerCount');
        return {
            showConfirm,
            playerCount,
            globalStats,
            statsID: this.$store.state.game.statsID
        };
    },
    sockets: {
        /* eslint-disable object-shorthand */
        'playerCount:update': function(count) {
            // console.log('new count:', count, this.playerCount);
            this.playerCount = count;
        }
    },
    computed: {
        ...mapGetters({
            points: 'points'
        }),
        filteredStats() {
            return this.globalStats.filter(e => e.points > 0);
        }
    },
    methods: {
        setShowConfirm(doShow) {
            this.showConfirm = doShow;
        },
        reset() {
            SaveService.initReset();
            this.$cookie.delete('token');
        }
    },
    components: {
        banner
    }
};
</script>
